import { all } from 'redux-saga/effects';
import authSagas from './auth/sagas';
import userSagas from './user/sagas';
import languageSagas from './language/sagas';
import voiceSagas from './voice/sagas';
import notificationSagas from './notification/sagas';
import projectSagas from './project/sagas';

function* rootSaga() {
  yield all([
    authSagas(),
    userSagas(),
    languageSagas(),
    voiceSagas(),
    notificationSagas(),
    projectSagas(),
  ]);
}

export default rootSaga;
